import React from "react";

import { TagProps } from "./tag.model";
import { CSSProperties } from "react";

export const Tag = ({
  tag,
  slug,
  className,
  style,
  onClick,
  selected = false,
  type = "primary",
}: TagProps) => {
  const testID = `tags__tag--${slug ?? tag}`;
  const classNames = `tags__tag tags__tag--${type} tags__tag--${onClick ? "clickable" : "static"} ${selected ? "tags__tag--selected" : ""} body-text-8${className ? ` ${className}` : ""}`;

  if (onClick) {
    return (
      <button
        type="button"
        aria-pressed={selected}
        data-testid={testID}
        className={classNames}
        style={style as CSSProperties}
        onClick={onClick}>
        {tag}
      </button>
    );
  }

  return (
    <span data-testid={testID} className={classNames} style={style as CSSProperties}>
      {tag}
    </span>
  );
};
